<template>
  <div>
  <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Archiv</li>
      </ol>
    </nav>
</div>

<b-form-group v-if="hasRoles(['Admin','Disponent'])"
    label="Filter"
    label-for="filter-input"
    label-cols-sm="1"
    content-cols-sm="12" content-col="6"
    label-align-sm="left"
    label-size="sm"
    class="mb-0">
    <b-input-group size="sm">
      <b-form-select
          id="input-search-role"
          class="ml-2"
          v-model="filterRole">
          <option value="0">Rolle wählen</option>
          <option v-for="(sp, idx) in roleOptions" v-bind:key="idx" :value="sp.value">{{sp.text}}</option>
      </b-form-select>
     <b-form-select v-model="filterUser" >
          <option v-for="(u, suidx) in filteredUsers.items" v-bind:key="suidx" :value="u.id">{{u.name}}</option>
     </b-form-select>
    <b-input-group-append>
      <b-button :disabled="!filterUser && !filterRole" @click="filterUser = null;filterRole = null">Zurücksetzen</b-button>
    </b-input-group-append>
  </b-input-group>
</b-form-group>

  <div class="table-responsive">
    <b-table
    id="item-table" thead-class="d-none"
    :current-page="currentPage"
    :per-page="perPage"
    :busy.sync="loading"
    show-empty
    :items="itemProvider"
    :fields="fields" >
     <template #table-busy>
        <div class="text-center  my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Lädt...</strong>
        </div>
      </template>
    <template #empty="scope">
      <b-alert v-if="!loading" :show="items.length==0" variant="info">Aktuell keine Einträge im Archiv</b-alert>
    </template>
    <template #cell(auftragStatus)="data">
      <AuftragOverview ref="AuftragOverview" :auftrag="data.item" @refresh-list="refresh"/>
    </template>
    </b-table>
</div>

    <b-pagination v-if="rowCount>perPage"  v-model="currentPage" :total-rows="rowCount"
      :per-page="perPage" aria-controls="item-table"></b-pagination>

  </div>
</template>

<script>
import api from '@/api/workflow'
import userApi from '@/api/benutzer'
import utils from '@/utilities'
import AuftragOverview from '@/components/partials/AuftragOverview'
import Role from '@/models/Role'

import AngebotOverview from '@/components/partials/AngebotOverview'
import afunc from '@/functions'

export default {
  name: 'Anfragen',
  components: {AngebotOverview, AuftragOverview},
  watch: {
    filterRole: function (value) {
      this.$root.$emit('bv::refresh::table', 'item-table')
    },
    filterUser: function (value) {
      this.$root.$emit('bv::refresh::table', 'item-table')
    },
    filter: function (value) {
      this.$root.$emit('bv::refresh::table', 'item-table')
    }
  },
  computed: {
    currentPage: {
      get: function () {
        return this.page
      },
      set: async function (newValue) {
        this.page = newValue
        this.offset = (this.page - 1) * this.perPage
        this.refresh()
      }
    },
    rows () {
      return this.pagedList.size
    }
  },
  data () {
    return {
      roles: this.$store.state.auth.baseData.roles,
      roleOptions: Role.asArchivFilterOptions(this.$store.state.auth.baseData.roles),
      loading: false,
      items: [],
      pagedList: {},
      fields: ['auftragStatus'],
      perPage: 50,
      rowCount: 0,
      page: 1,
      offset: 0,
      filteredUsers: [],
      filter: null,
      filterUser: null,
      filterRole: 0,
      msg: ''
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    hasRoles (roles) {
      // make sure to take the roles from the token, as normal user doent have the roles in the user object
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), roles)
    },
    uploadFile (id) {
      afunc.uploadFile(this, api, id)
    },
    actionFunc (action, id) {
      afunc.actionFunc(this, api, action, id, new FormData())
    },
    statusColor (item) {
      switch (item.auftragStatus) {
        case 'Angelegt':
          return 'bg-light'
      }
    },
    mkTitel (data, mark) {
      return utils.mkTitel(data, mark)
    },
    async updateUserSelect (items) {
      switch (this.filterRole) {
        case Role.Cutter:
          this.filteredUsers = await userApi.search(0, -1, {'role': 'Cutter', 'enabled': false})
          break
        case Role.Disponent:
          this.filteredUsers = await userApi.search(0, -1, {'role': 'Disponent', 'enabled': true})
          break
        case Role.Kunde:
          this.filteredUsers = await userApi.search(0, -1, {'role': 'Kunde', 'enabled': true})
          break
      }
    },
    async itemProvider (ctx) {
      try {
        const offset = (ctx.currentPage - 1) * ctx.perPage
        const pagedList = await api.archiv(offset, ctx.perPage, {'id': this.filterUser, 'role': this.filterRole})
        this.rowCount = pagedList.size
        this.listValues = pagedList.items
        this.updateUserSelect(pagedList.items)
        return pagedList.items
      } catch (error) {
        return []
      }
    },
    async update () {
      this.$root.$emit('bv::refresh::table', 'item-table')
    },
    async refresh () {
      this.update()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Archiv.vue